import { render, staticRenderFns } from "./answerContent.vue?vue&type=template&id=7b6735eb"
import script from "./answerContent.vue?vue&type=script&lang=js"
export * from "./answerContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports